export default __webpack_public_path__ + "static/media/cycle.8e5564df.webp";